const PROPERTY_TYPE = {

  id: "property_type",
  type: "dropdown",
  props: {
    isMulti: true,
    optionFilter: (item, formValues) => {
      const property_type_group = formValues.property_type_group?.value;
      if (property_type_group) {
        return item.category === property_type_group;
      }
      return true;
    },
    dropdownProps: {
      label: "Sub Type",
      buttonProps: {
        className: "property_type",
      },
      menuProps: {
        style: {
          // minWidth: 300
        }
      }
    },
    options: [
      // HDB
      { label: "1-Room", value: "1-Room", category: "HDB" },
      { label: "2-Room", value: "2-Room", category: "HDB" },
      { label: "3-Room", value: "3-Room", category: "HDB" },
      { label: "4-Room", value: "4-Room", category: "HDB" },
      { label: "5-Room", value: "5-Room", category: "HDB" },
      { label: "Jumbo", value: "Jumbo", category: "HDB" },
      { label: "Multi-Generation", value: "Multi-Generation", category: "HDB" },
      { label: "Executive Apartment", value: "Executive Apartment", category: "HDB" },
      { label: "Executive Maisonette", value: "Executive Maisonette", category: "HDB" },
      // { label: "HDB (Unspecified)", value: "HDB (Unspecified)", category: "HDB" },
      // Non-Landed
      { label: "Apartment", value: "Apartment", category: "Non-Landed" },
      { label: "Condominium", value: "Condominium", category: "Non-Landed" },
      { label: "Executive Condominium", value: "Executive Condominium", category: "Non-Landed" },
      // Landed
      { label: "Terrace House", value: "Terrace House", category: "Landed" },
      { label: "Corner Terrace", value: "Corner Terrace", category: "Landed" },
      { label: "Cluster House", value: "Cluster House", category: "Landed" },
      { label: "Town House", value: "Town House", category: "Landed" },
      { label: "Semi-Detached House", value: "Semi-Detached House", category: "Landed" },
      { label: "Detached House", value: "Detached House", category: "Landed" },
      { label: "Bungalow", value: "Bungalow", category: "Landed" },
      { label: "Good Class Bungalow", value: "Good Class Bungalow", category: "Landed" },
      { label: "Conservation House", value: "Conservation House", category: "Landed" },
      // Office
      { label: "Office", value: "Office", category: "Office" },
      { label: "Business / Science Park", value: "Business / Science Park", category: "Office" },
      // Retail
      { label: "Shophouse", value: "Shophouse", category: "Retail" },
      { label: "Mall Shop", value: "Mall Shop", category: "Retail" },
      { label: "Medical", value: "Medical", category: "Retail" },
      { label: "Other Retail", value: "Other Retail", category: "Retail" },
      { label: "Shop", value: "Shop", category: "Retail" },
      { label: "Food & Beverage", value: "Food & Beverage", category: "Retail" },
      // Industrial
      { label: "Light Industrial (B1)", value: "Light Industrial (B1)", category: "Industrial" },
      { label: "Factory / Workshop (B2)", value: "Factory / Workshop (B2)", category: "Industrial" },
      { label: "Warehouse", value: "Warehouse", category: "Industrial" },
      { label: "Dormitory", value: "Dormitory", category: "Industrial" },
      // Land
      { label: "Residential Land", value: "Residential Land", category: "Land" },
      { label: "Land", value: "Land", category: "Land" },
      { label: "Enbloc", value: "Enbloc", category: "Land" },
    ]
  }

}

const COL_PROPERTY_TYPE = {

  id: "col_property_type",
  type: "col",
  props: {
    lg: 3,
    md: 4,
    xs: 6,
  },
  children: [PROPERTY_TYPE]

}

const COL_MODAL_PROPERTY_TYPE = {

  id: "col_property_type",
  type: "col",
  props: {
    lg: 6,
    md: 6,
    xs: 6,
  },
  children: [PROPERTY_TYPE]

}

export { PROPERTY_TYPE, COL_PROPERTY_TYPE, COL_MODAL_PROPERTY_TYPE };
